import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Paper,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  useTheme
} from '@mui/material';
import Category from '@mui/icons-material/Category';
import CloseIcon from '@mui/icons-material/Close';
import { FuelSource } from '../types';
import { ElectricalServices } from '@mui/icons-material';

interface FuelSourceFormModalProps {
  openFS: boolean;
  onClose: () => void;
  onSubmit: (data: FuelSource) => void;
  fuelSource?: FuelSource;
  isEditMode?: boolean;
}

const AddNewFuelSourcePopUp: React.FC<FuelSourceFormModalProps> = ({ openFS, onClose, onSubmit, fuelSource, isEditMode }) => {
  const theme = useTheme();
  
  const commonTextFieldStyles = {
    mb: 2,
    backgroundColor: theme.palette.mode === 'light' ? 'white' : theme.palette.background.paper,
    borderRadius: 1
  };
  const [id, setId] = useState<number | ''>('');
  const [fsName, setFSName] = useState('');
  const [fsLocation, setFSLocation] = useState('');
  const [fsLatitude, setFSLatitude] = useState<number | ''>('');
  const [fsLongitude, setFSLongitude] = useState<number | ''>('');
  const [fsSortOrder, setFSSortOrder] = useState<number | ''>('');
  const [fsIsActive, setFSIsActive] = useState(true);

  useEffect(() => {
      if(isEditMode && fuelSource){
        setId(fuelSource.id);
        setFSName(fuelSource.name);
        setFSLocation(fuelSource.location);
        setFSLatitude(fuelSource.latitude);
        setFSLongitude(fuelSource.longitude);
        setFSSortOrder(fuelSource.sortOrder);
        setFSIsActive(fuelSource.isActive);
      }
      else{
        setId(0);
        setFSName('');
        setFSLocation('');
        setFSLatitude('');
        setFSLongitude('');
        setFSSortOrder('');
        setFSIsActive(true);
      }
  },[isEditMode, fuelSource]);

  const handleSubmit = () => {
      const payload: FuelSource = {
        id: fuelSource?.id || 0,
        name: fsName,
        location: fsLocation,
        latitude: Number(fsLatitude),
        longitude: Number(fsLongitude),
        sortOrder: Number(fsSortOrder),
        isActive: fsIsActive
      };
      onSubmit(payload);
    };

    return (
        <Dialog open={openFS} onClose={onClose} maxWidth="md" fullWidth>
              <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="h6">
                    <Category /> Add New Fuel Source
                  </Typography>
                  <IconButton onClick={onClose}>
                    <CloseIcon />
                  </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                    <Paper elevation={0} sx={{ p: 2, backgroundColor: 'transparent', borderRadius: 2 }}>
                      <Grid container spacing={3}>
                        {/* Left Column */}
                        <Grid item xs={12} md={6}>
                          <TextField fullWidth 
                            label="Source Name" 
                            variant="outlined" 
                            sx={commonTextFieldStyles} 
                            value = {fsName}
                            onChange={(e) => setFSName(e.target.value)}
                            />
                          <TextField fullWidth 
                            label="Latitude"
                            type="number" 
                            variant="outlined" 
                            sx={commonTextFieldStyles}
                            value={fsLatitude}
                            onChange={(e) => setFSLatitude(Number(e.target.value))} 
                            />
                          <TextField fullWidth 
                            label="Sort Order" 
                            type="number" 
                            variant="outlined" 
                            sx={commonTextFieldStyles}
                            value={fsSortOrder}
                            onChange={(e) => setFSSortOrder(Number(e.target.value))} 
                            />
                        </Grid>
            
                        {/* Right Column */}
                        <Grid item xs={12} md={6}>
                            <TextField fullWidth 
                              label="Location" 
                              variant="outlined" 
                              sx={commonTextFieldStyles}
                              value={fsLocation}
                              onChange={(e) => setFSLocation(e.target.value)} 
                              />
                            <TextField fullWidth 
                              label="Longitude"
                              type="number"
                              variant="outlined" 
                              sx={commonTextFieldStyles}
                              value={fsLongitude}
                              onChange={(e) => setFSLongitude(Number(e.target.value))} 
                              />
                        </Grid>
            
                        {/* Checkbox */}
                        <Grid item xs={12}>
                          <FormControlLabel
                              control={
                              <Checkbox
                              checked={fsIsActive}
                              onChange={(e) => setFSIsActive(e.target.checked)}
                              />
                              }
                          label="Active Fuel Type"
                          sx={{ mb: 2 }}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </DialogContent>
            
                  <DialogActions>
                          <Button
                            variant="contained"
                            sx={{ background: 'linear-gradient(135deg, #667eea 0%, #4c5fd7 100%)',
                '&:hover': { background: 'linear-gradient(135deg, #4c5fd7 0%, #c2410c 100%)' } }}
                            onClick={handleSubmit}
                          >
                            {isEditMode ? 'Update Fuel Source' : 'Create Fuel Source'}
                          </Button>
                          <Button
                            variant="contained"
                            sx={{ background: 'linear-gradient(135deg, #667eea 0%, #4c5fd7 100%)',
                '&:hover': { background: 'linear-gradient(135deg, #4c5fd7 0%, #c2410c 100%)' } }}
                            onClick={onClose}
                          >
                            Cancel
                          </Button>
                        </DialogActions>
        </Dialog>
    );
};
export default AddNewFuelSourcePopUp;